import { positions } from "react-alert";

export const alertOptions = {
  timeout: 5000,
  position: positions.TOP_CENTER,
};
